import { shuffle } from 'lodash';
import React, { useMemo } from 'react';
import { FieldAnswerFeedbackWUT } from '../../../ui/field-answer-feedback/field-answer-feedback-wut';
import { QuizQuestionWut } from '../../../ui/quiz/quiz-question/quiz-question-wut';
import { NUMBER_OF_COLUMNS } from '../../../ui/options-layout/options-layout-constants';
import { useFieldAttributes } from '../../../services/field-attributes';
import { RadioGroupInputWUT } from '../../../inputs/radio-group-input-wut/radio-group-input-wut';
import { FieldErrorWUT } from '../../../ui/field-error/field-error-wut';
import { FieldDescriptionWUT } from '../../../ui/field-description/field-description-wut';
export const QuizSingleChoiceWUT = _ref => {
  let {
    id,
    target,
    label,
    hideLabel = false,
    options: _options,
    description,
    addOther,
    addOtherLabel,
    addOtherPlaceholder,
    required,
    value,
    onChange,
    onFocus,
    onBlur,
    error,
    hasError = false,
    errorMessage,
    disabled = false,
    otherInputCharacterLimit,
    FieldLayout,
    numberOfColumns = NUMBER_OF_COLUMNS.ONE,
    requiredIndicatorType,
    randomizeChoices,
    requiredIndicatorPlacement,
    externalData,
    questionImage,
    questionImageResize,
    questionImageAlignment,
    questionImagePlacement,
    questionImageAltText
  } = _ref;
  const options = useMemo(() => randomizeChoices ? shuffle(_options) : _options, [_options, randomizeChoices]);
  const {
    labelId,
    inputId,
    errorId,
    descriptionId,
    ariaDescribedBy
  } = useFieldAttributes(id, error, description);
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id,
    renderLabel: () => /*#__PURE__*/React.createElement(QuizQuestionWut, {
      htmlFor: inputId,
      labelId: labelId,
      id: id,
      error: error,
      description: description,
      required: required,
      label: label,
      hideLabel: hideLabel,
      requiredIndicatorType: requiredIndicatorType,
      requiredIndicatorPlacement: requiredIndicatorPlacement,
      image: questionImage,
      imageResize: questionImageResize,
      imageAlignment: questionImageAlignment,
      imagePlacement: questionImagePlacement,
      imageAltText: questionImageAltText
    }),
    renderInput: () => /*#__PURE__*/React.createElement(RadioGroupInputWUT, {
      target: target,
      inputId: inputId,
      labelId: labelId,
      hasError: hasError,
      options: options,
      ariaDescribedBy: ariaDescribedBy,
      addOther: addOther,
      addOtherLabel: addOtherLabel,
      addOtherPlaceholder: addOtherPlaceholder,
      required: required,
      value: value,
      onChange: onChange,
      onFocus: onFocus,
      onBlur: onBlur,
      disabled: disabled,
      otherInputCharacterLimit: otherInputCharacterLimit,
      numberOfColumns: numberOfColumns
    }),
    renderDescription: () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FieldErrorWUT, {
      target: target,
      hasError: hasError,
      errorMessage: errorMessage,
      id: errorId
    }), /*#__PURE__*/React.createElement(FieldDescriptionWUT, {
      description: description,
      id: descriptionId
    }), /*#__PURE__*/React.createElement(FieldAnswerFeedbackWUT, {
      target: target,
      externalData: externalData
    }))
  });
};
//# sourceMappingURL=quiz-single-choice-wut.js.map